import { gql } from '@apollo/client';

export const PROPERTY_DOCUMENTS_FRAGMENT = gql`
  fragment PropertyDocuments on Property {
    documents {
      list {
        name
        url
      }
    }
  }
`;
